export default "/images/vendor/flag-icon-css/flags/1x1/ag.svg?c0ddd54bc36224674514784c0fad9f26";